body {
  .xm-table-util-labeled {
    width: 100%; // 99%
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 0.5em;
    padding-right: 4px;

    >div {
      width: 0;
      flex-grow: 1;
      display: inline-flex;
      justify-content: space-between;
      align-items: center;
    }

    a.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    a:not(:nth-of-type(1)) {
      margin-left: 0.5em;
    }

    .xm-icon {
      &-large.xm-icon {
        font-size: 1.8em;
      }

      &-medium.xm-icon {
        font-size: 1.2em;
      }
    }

    .xm-table-label {
      font-weight: var(--xm-font-weight-medium);
      white-space: pre;
    }

    .xm-table-controls {
      text-wrap: nowrap;
      align-self: end;
    }
  }

  .xm-table-util {
    margin-right: 4px;
    align-self: flex-end;
    display: flex;
    align-items: center;
    flex-grow: 1;

    >div {
      width: auto;
      flex-grow: 1;
      text-align: end;
    }

    a.disabled {
      opacity: 0.6;
      color: #484848;
      cursor: not-allowed;
    }

    a:not(:nth-of-type(1)) {
      margin-left: 0.5em;
    }

    .xm-icon {
      &-large.xm-icon {
        font-size: 1.8em;
      }

      &-medium.xm-icon {
        font-size: 1.2em;
      }
    }
  }

  a.xm-tbl-star {
    align-items: center;
    justify-content: center;
    margin: 0.5em 0;
  }
}

div#root {
  .xm-tbl-star {
    align-items: center;
    justify-content: center;

    &.xm-tbl-in-dash {

      &,
      &:hover,
      * {
        color: var(--xm-fav-color);
      }
    }

    &.xm-tbl-not-dash {
      color: var(--ant-color-text-secondary);

      &:hover {
        color: var(--ant-color-text);
      }
    }
  }
}